import { PARTNER_LEGAL_LINKS } from '@houzy/schemas/legal-documents';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import type { ReactElement } from 'react';
import { Trans } from 'react-i18next';

function TermsLabel(): ReactElement {
    return (
        <Box
            component="span"
            sx={(theme) => ({
                ...theme.typography.body2,
                color: theme.palette.text.secondary,
            })}>
            <Trans
                i18nKey="ONBOARDING.REGISTER.TERMS"
                components={{
                    terms: (
                        <Link
                            href={PARTNER_LEGAL_LINKS.termsOfService}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        />
                    ),
                    privacy: (
                        <Link
                            href={PARTNER_LEGAL_LINKS.dataPolicy}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        />
                    ),
                }}
            />
        </Box>
    );
}

export type TermsConsentProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

export function TermsConsent({ checked, onChange }: TermsConsentProps): ReactElement {
    return (
        <FormControlLabel
            control={<Checkbox checked={checked} onChange={(event) => onChange(event.target.checked)} />}
            label={<TermsLabel />}
        />
    );
}
